export const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL ?? "https://rest.primalt.com/"

export const API_PUBLIC = 'api/'